module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAMAAABYzB2OAAAAWlBMVEUAAFUAAF0AAGUAAGYAAGwAAG0AAG8AAHQAAHYAAH0AAH4AAIUAAIYAAIwAAI0AAJQAAJuYAACuAADCAADEAADWAADW1tbYAADqAADsAADs7Oz+AAD/AAD////2YpP+AAAATklEQVR42rXIyRWAIAwFwI+7RETBiHHpv019OUEBznGweEdEj7oV/DxZa7O64Kbuk9UBsmUJ/13jUFaK6NvaGHMqEUlbQFMZALti5hjWF/tjEUDK6LKDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag/fr.png
// module id = 0O+S
// module chunks = 1